export default "__VITE_ASSET__DvecjBrX__"